module.exports = __webpack_public_path__ + "static/media/time.c1c119eb.svg";